import React from 'react';
import styled from '@emotion/styled';

const Div = styled.div`
  transform: scale(1.4);
`;

const Switch = ({ id, onChange, checked, loading }) => (
  <Div className="custom-control custom-switch">
    <input
      id={id}
      type="checkbox"
      className="custom-control-input"
      onChange={(e) => {
        if (typeof onChange === 'function') {
          onChange(e.target.checked);
        }
      }}
      checked={checked}
      disabled={loading}
    />
    <label className="custom-control-label" htmlFor={id} />
  </Div>
);

export default Switch;
